
import gql from 'graphql-tag';

const CONVERT_PROSPECT_TO_LEAD = gql` 
  mutation convertProspectToLead($input: ConvertProspectInput!) {
    convertProspectToLead(input: $input) {
      message
      code
      data {
        successData {
          id
          first_name_1
          last_name_1
        }
        failureData {
          id
          first_name_1
          last_name_1
        }
        communities {
          name
        }
      }
    }
  }
`;

export default CONVERT_PROSPECT_TO_LEAD;